import { safeJSONParse } from "@/utils";
import {
  IShopCategoryResponse,
  IShopHistoryItem,
  IShopHistoryItemResponse,
  IShopItemResponse,
} from "../types";

export const serializeShopItem = (item: IShopItemResponse) => {
  const categoryNameObject = safeJSONParse<Record<string, string>>(item.category.name, {});
  const tokenNameObject = safeJSONParse<Record<string, string>>(item.token.name, {});
  const nameObject = safeJSONParse<Record<string, string>>(item.name, {});
  return {
    ...item,
    name: (Object.values(nameObject)[0] as string) || "",
    nameTranslations: nameObject,
    category: {
      name: (Object.values(categoryNameObject)[0] as string) || "",
      translations: categoryNameObject,
    },
    token: {
      id: item.token.id,
      name: (Object.values(tokenNameObject)[0] as string) || "",
      image: item.token.image,
      translations: tokenNameObject,
    },
  };
};

export const serializeShopCategory = (item: IShopCategoryResponse) => {
  const categoryNameObject = safeJSONParse<Record<string, string>>(item.name, {});
  return {
    ...item,
    name: (Object.values(categoryNameObject)[0] as string) || "",
    translations: categoryNameObject,
  };
};

export const serializeHistoryShopItem = (data: IShopHistoryItemResponse) => {
  const item = data.item;
  const categoryNameObject = safeJSONParse<Record<string, string>>(item.category.name, {});
  const tokenNameObject = safeJSONParse<Record<string, string>>(item.token.name, {});
  const nameObject = safeJSONParse<Record<string, string>>(item.name, {});

  return {
    ...data,
    paidAmount: (parseFloat(item?.paidAmount ?? "") || 0).toFixed(2),
    date: data.createdAt?.split("T")[0] || "Unknown Date",
    item: {
      ...item,
      name: (Object.values(nameObject)[0] as string) || "",
      nameTranslations: nameObject,
      category: {
        name: (Object.values(categoryNameObject)[0] as string) || "",
        translations: categoryNameObject,
      },
      token: {
        id: item.token.id,
        name: (Object.values(tokenNameObject)[0] as string) || "",
        image: item.token.image,
        translations: tokenNameObject,
      },
    },
  };
};

export const serializeUserShopItems = (data: IShopHistoryItemResponse[]) => {
  const serializedData = data.map((item) => serializeHistoryShopItem(item));
  return serializedData.reduce(
    (acc, item) => {
      const date = item.date;
      if (!acc[date]) {
        acc[date] = [];
      }
      acc[date].push(item);
      return acc;
    },
    {} as Record<string, IShopHistoryItem[]>
  );
};

export const stockTitleHelper = (stock: number, t: any) => {
  if (stock === 0) return t("shop.outOfStock");

  return t("shop.stockLeft", { stock });
};
